import { BaseService } from "./BaseService";

export const PpagService = {
    async index(filter = null) {
        try {
            return await BaseService.fetchResponseFromAPIPost('ppag/search', filter);
        } catch (error) {
            console.error('Ocorreu um erro ao listar todos ppags:', error);
            return false;
        }
    },
    async store(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('ppag', postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a criação de ppags:', error);
            return false;
        }
    },
    async show(id) {
        try {
            return await BaseService.fetchResponseFromAPIGet(`ppag/${id}`);
        } catch (error) {
            console.error('Ocorreu um erro durante a busca de ppags:', error);
            return false;
        }
    }, 
    async update(id, postData) {
        try {
            postData.append("_method", "PUT");
            return await BaseService.fetchResponseFromAPIPost(`ppag/${id}`, postData);
        } catch (error) {
            console.error('Ocorreu um erro durante a atualização de ppags:', error);
            return false;
        }
    }, 
    async destroy(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('ppag/destroy', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao excluir ppags:', error);
            return false;
        }
    }, 
    async activate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('ppag/activate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao ativar ppags:', error);
            return false;
        }
    }, 
    async deactivate(postData) {
        try {
            return await BaseService.fetchResponseFromAPIPost('ppag/deactivate', postData);
        } catch (error) {
            console.error('Ocorreu um erro ao desativar ppags:', error);
            return false;
        }
    }, 
}